import { EyeIcon, EyeSlashIcon, LockIcon } from '@phosphor-icons/react';
import React, { useState } from 'react';

interface PasswordInputProps extends React.ComponentProps<'input'> {
  disabled?: boolean;
  placeholder: string;
  helperText?: string;
  error?: string;
}

export function PasswordInput({
  disabled,
  placeholder,
  helperText,
  error,
  ...props
}: PasswordInputProps) {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="self-stretch inline-flex flex-col justify-start items-start gap-1.5">
      <div
        className={`self-stretch px-3.5 py-2.5 rounded-lg outline-1 outline-offset-[-1px] inline-flex justify-start items-center gap-2 overflow-hidden input-shadow transition-colors ${
          disabled ? 'bg-gray-50' : 'bg-white'
        } ${
          error
            ? 'input-error outline-error-300 focus-within:outline-error-300'
            : 'outline-gray-300 focus-within:outline-blue-300'
        }`}
      >
        <div className="flex-1 flex justify-start items-center gap-2">
          <LockIcon className="text-gray-500 size-5" />
          <input
            className="flex-1 justify-start placeholder:text-gray-500 text-gray-900 text-base font-normal leading-normal outline-none"
            placeholder={placeholder}
            type={showPassword ? 'text' : 'password'}
            {...props}
          />
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="text-gray-500 hover:text-gray-700 transition-colors p-1"
            disabled={disabled}
          >
            {showPassword ? <EyeSlashIcon size={22} /> : <EyeIcon size={22} />}
          </button>
        </div>
      </div>
      {error ? (
        <div className="self-stretch justify-start text-error-500 text-xs font-normal leading-none">
          {error}
        </div>
      ) : (
        <div className="self-stretch justify-start text-gray-600 text-xs font-normal leading-none">
          {helperText}
        </div>
      )}
    </div>
  );
}
